/**************************************************
 * Nombre:       Home_Manejamos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Caracteristicas from "../../Tarjetas/Tarjeta_Caracteristicas";
import {useState} from "react";
import celular from '../../../Recursos/celular.png'
import persona from '../../../Recursos/persona.png'
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Home_Manejamos = () => {
    const [escogido, setEscogido] = useState('Seguridad');
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3,}}
                spacing={4}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography
                        sx={{
                            fontSize: 32,
                            fontWeight: 600,
                            textAlign: 'center',
                            width: sCell ? '100%' : '35%',
                            lineHeight: 1.1,
                        }}>
                        Manejamos la mejor tecnología
                    </Typography>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-end'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{borderLeft: 6, mt: 4}}
                >


                    <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{

                                p: 4
                            }}
                            spacing={0}
                        >

                            {items.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Tarjeta_Caracteristicas item={item} escodigo={escogido} setEsgogido={setEscogido}/>
                                </Grid>
                            ))}

                        </Grid>
                    </Grid>

                    {!sCell &&

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-end'}} spacing={4}>
                            <img src={celular} width={'auto'} height={500} style={{borderRadius: 30}}/>
                            <img src={persona}
                                 width={'auto'}
                                 height={500}
                                 style={{borderRadius: 30}}/>

                        </Grid>
                    }


                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Manejamos

const items = [
    {
        nombre: 'Seguridad',
        descripcion: 'Protegemos tus activos e información personal mediante infraestructura tecnológica avanzada y protocolos de seguridad de nivel bancario. Nos aseguramos de que cada transacción y consulta se realice en un entorno blindado, transparente y confiable.'
    },
    {
        nombre: 'Facilidad',
        descripcion: 'Sin papeleos ni complicaciones. Una plataforma ágil y amigable diseñada para que manejes tus ahorros e información de forma intuitiva, directo desde tu celular o computadora.'
    },
    {
        nombre: 'Educación',
        descripcion: 'El conocimiento es la clave para hacer rendir tu esfuerzo. Ponemos a tu alcance recursos educativos diseñados para la comunidad, ayudándote a entender cómo funciona el dinero, cómo establecer metas claras y cómo construir un patrimonio sólido para ti y tu familia.'
    },
]